import { JsaStats } from "../models/jsa-stats.model";
import { JsaStatsStateModel } from "../state/jsa-stats.state";

export namespace JsaStatsActions {
    export class Refresh {
        static readonly type = '[API-JSA-STATS] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-JSA-STATS] Increment Pending Count'
        constructor() {}
    }
    export class Init {
        static readonly type = '[API-JSA-STATS] Init'
        constructor(public payload: JsaStatsStateModel) {}
    }
    export class Set {
        static readonly type = '[API-JSA-STATS] Set'
        constructor(public payload: JsaStats[]) {}
    }
    export class Merge {
        static readonly type = '[API-JSA-STATS] Merge'
        constructor(public payload: JsaStats[]) {}
    }
}
